import { StorageService } from './../../services/storage/storage.service';
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';

// import {environment} from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-systems',
  templateUrl: './modal-systems.component.html',
  styleUrls: ['./modal-systems.component.scss']
})
export class ModalSystemsComponent implements OnInit {
  

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private storageService:StorageService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalSystemsComponent>
  ) { }

  ngOnInit(): void {
  }


}
